export const TwilioIcon = (props: React.ComponentPropsWithoutRef<'svg'>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        d="M10 2.5C5.85 2.5 2.5 5.85 2.5 10C2.5 14.15 5.85 17.5 10 17.5C14.15 17.5 17.5 14.15 17.5 10C17.5 5.85 14.15 2.5 10 2.5ZM10 15.5C6.95 15.5 4.5 13.05 4.5 10C4.5 6.95 6.95 4.5 10 4.5C13.05 4.5 15.5 6.95 15.5 10C15.5 13.05 13.05 15.5 10 15.5ZM13.4 8.15C13.4 9 12.7 9.7 11.85 9.7C11 9.7 10.3 9 10.3 8.15C10.3 7.3 11 6.6 11.85 6.6C12.7 6.6 13.4 7.3 13.4 8.15ZM13.4 11.85C13.4 12.7 12.7 13.4 11.85 13.4C11 13.4 10.3 12.7 10.3 11.85C10.3 11 11 10.3 11.85 10.3C12.7 10.3 13.4 11 13.4 11.85ZM9.7 11.85C9.7 12.7 9 13.4 8.15 13.4C7.3 13.4 6.6 12.7 6.6 11.85C6.6 11 7.3 10.3 8.15 10.3C9 10.3 9.7 11 9.7 11.85ZM9.7 8.15C9.7 9 9 9.7 8.15 9.7C7.3 9.7 6.6 9 6.6 8.15C6.6 7.3 7.3 6.6 8.15 6.6C9 6.6 9.7 7.3 9.7 8.15Z"
        fill="#F22F46"
      />
    </svg>
  );
};
